import {Component, OnInit} from '@angular/core';
import {CpProvisionTypeBaseComponent} from '../base/cp-provision-type-base.component';

/**
 * Side view of the ProvisionType object component (`uiMode = 'side' | 'mini-side'`, PAT §L.2).
 *
 * In-module precedent: `../../../cp-provision-agent-object/view/side/`; its own reference is
 * `bm-billing-area-side.component.ts`. The sidebar defaults to the master form because that is
 * what a narrow pane can show usefully; the wide child lists are still reachable through
 * `?sideNavItem=` and are then rendered in place.
 */
@Component({
    selector: 'cp-provision-type-side',
    templateUrl: './cp-provision-type-side.component.html',
    styleUrls: ['./cp-provision-type-side.component.scss'],
    standalone: false
})
export class CpProvisionTypeSideComponent extends CpProvisionTypeBaseComponent implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
